import React from "react"
import { setSiteEnvVars } from "../utils"

export default function useSetFSRole(role) {
  React.useEffect(() => {
    setSiteEnvVars(role)
  }, [role])
}
